<script setup lang="ts">
import type { GeneralButtonFragment } from '#graphql-operations'

withDefaults(defineProps<{
  title?: string
  links: GeneralButtonFragment[]
}>(), {
  title: () => '',
})

const quicklinks = ref<HTMLElement | null>(null)

const { loadIcon } = useDynamicIcons()

const { arrivedState } = useScroll(quicklinks)
</script>

<template>
  <div
    class="quick-links"
    :class="{
      'quick-links--start': arrivedState.left,
      'quick-links--end': arrivedState.right,
    }"
  >
    <slot />

    <UiHeading
      v-if="title"
      class="quick-links__heading"
    >
      {{ title }}
    </UiHeading>

    <div class="quick-links__container">
      <ul
        ref="quicklinks"
        class="quick-links__list"
      >
        <li
          v-for="(link, index) in links"
          :key="index"
          class="quick-links__item"
        >
          <AppLink
            v-if="link?.Link"
            class="quick-links__button"
            :to="link.Link"
          >
            <component
              :is="loadIcon(link?.Icon)"
              v-if="link?.Icon"
              class="quick-links__icon icon"
              :class="`icon--${useDash(link.Icon)}`"
              filled
            />
            <span>{{ link.Text }}</span>
          </AppLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style src="~layers/components/Catalog/QuickLinks.css" />
